import { InitPagedData } from "./../Utils";
import { GoodIssueStateTypes, GoodIssueActionTypes } from "./GoodIssue.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: GoodIssueStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchList: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchPaged: resetApiCallState(InitPagedData),
  fetchReport: resetApiCallState([]),
  fetchVehicleReport: resetApiCallState([]),
  fetchFormanReport: resetApiCallState([]),
  fetchConsumptionReport: resetApiCallState([]),
};

const GoodIssueReducer = (
  state: GoodIssueStateTypes = INITIAL_STATE,
  action: any
): GoodIssueStateTypes => {
  switch (action.type) {
    case GoodIssueActionTypes.FETCH_ALL_GOOD_ISSUE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodIssueActionTypes.FETCH_ALL_GOOD_ISSUE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case GoodIssueActionTypes.FETCH_ALL_GOOD_ISSUE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodIssueActionTypes.FETCH_ALL_GOOD_ISSUE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------------

    case GoodIssueActionTypes.FETCH_ALL_LIST_GOOD_ISSUE:
      return {
        ...state,
        fetchList: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodIssueActionTypes.FETCH_ALL_LIST_GOOD_ISSUE_RESET:
      return {
        ...state,
        fetchList: resetApiCallState([]),
      };
    case GoodIssueActionTypes.FETCH_ALL_LIST_GOOD_ISSUE_FAILURE:
      return {
        ...state,
        fetchList: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodIssueActionTypes.FETCH_ALL_LIST_GOOD_ISSUE_SUCCESS:
      return {
        ...state,
        fetchList: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------------
    case GoodIssueActionTypes.FETCH_REPORT_GOOD_ISSUE:
      return {
        ...state,
        fetchReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodIssueActionTypes.FETCH_REPORT_GOOD_ISSUE_RESET:
      return {
        ...state,
        fetchReport: resetApiCallState([]),
      };
    case GoodIssueActionTypes.FETCH_REPORT_GOOD_ISSUE_FAILURE:
      return {
        ...state,
        fetchReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodIssueActionTypes.FETCH_REPORT_GOOD_ISSUE_SUCCESS:
      return {
        ...state,
        fetchReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case GoodIssueActionTypes.FETCH_PAGED_GOOD_ISSUE:
      return {
        ...state,
        fetchPaged: {
          error: null,
          payload: InitPagedData,
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodIssueActionTypes.FETCH_PAGED_GOOD_ISSUE_RESET:
      return {
        ...state,
        fetchPaged: resetApiCallState(InitPagedData),
      };
    case GoodIssueActionTypes.FETCH_PAGED_GOOD_ISSUE_FAILURE:
      return {
        ...state,
        fetchPaged: {
          payload: InitPagedData,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodIssueActionTypes.FETCH_PAGED_GOOD_ISSUE_SUCCESS:
      return {
        ...state,
        fetchPaged: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case GoodIssueActionTypes.FETCH_ONE_GOOD_ISSUE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodIssueActionTypes.FETCH_ONE_GOOD_ISSUE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case GoodIssueActionTypes.FETCH_ONE_GOOD_ISSUE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodIssueActionTypes.FETCH_ONE_GOOD_ISSUE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case GoodIssueActionTypes.FETCH_VEHICLE_REPORT_GOOD_ISSUE:
      return {
        ...state,
        fetchVehicleReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodIssueActionTypes.FETCH_VEHICLE_REPORT_GOOD_ISSUE_RESET:
      return {
        ...state,
        fetchVehicleReport: resetApiCallState([]),
      };
    case GoodIssueActionTypes.FETCH_VEHICLE_REPORT_GOOD_ISSUE_FAILURE:
      return {
        ...state,
        fetchVehicleReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodIssueActionTypes.FETCH_VEHICLE_REPORT_GOOD_ISSUE_SUCCESS:
      return {
        ...state,
        fetchVehicleReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -----------------------

    case GoodIssueActionTypes.FETCH_GOOD_ISSUE_FORMAN_REPORT:
      return {
        ...state,
        fetchFormanReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodIssueActionTypes.FETCH_GOOD_ISSUE_FORMAN_REPORT_RESET:
      return {
        ...state,
        fetchFormanReport: resetApiCallState([]),
      };
    case GoodIssueActionTypes.FETCH_GOOD_ISSUE_FORMAN_REPORT_FAILURE:
      return {
        ...state,
        fetchFormanReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodIssueActionTypes.FETCH_GOOD_ISSUE_FORMAN_REPORT_SUCCESS:
      return {
        ...state,
        fetchFormanReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -----------------------

    case GoodIssueActionTypes.FETCH_GOOD_ISSUE_CONSUMPTION_REPORT:
      return {
        ...state,
        fetchConsumptionReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodIssueActionTypes.FETCH_GOOD_ISSUE_CONSUMPTION_REPORT_RESET:
      return {
        ...state,
        fetchConsumptionReport: resetApiCallState([]),
      };
    case GoodIssueActionTypes.FETCH_GOOD_ISSUE_CONSUMPTION_REPORT_FAILURE:
      return {
        ...state,
        fetchConsumptionReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodIssueActionTypes.FETCH_GOOD_ISSUE_CONSUMPTION_REPORT_SUCCESS:
      return {
        ...state,
        fetchConsumptionReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default GoodIssueReducer;
